import {
  HttpEventType,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Auth } from 'aws-amplify';

import { Subscription, throwError } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';
import { APIService } from 'src/app/API.service';
import { environment } from 'src/environments/environment';
import { D2TApi } from 'src/app/doc2txt/utils/d2tApi';
import { OcrPlusComponent } from '../ocr-plus/ocr-plus.component';
import { OcrPlusCanvasComponent } from '../ocr-plus-canvas/ocr-plus-canvas.component';

@Component({
  selector: 'app-ocr-plus-upload',
  templateUrl: './ocr-plus-upload.component.html',
  styleUrls: ['./ocr-plus-upload.component.css'],
})
export class OcrPlusUploadComponent {
  @ViewChild('canvasComp') canvasCompRf: ElementRef<OcrPlusCanvasComponent>;
  @ViewChild('canvasCompContain') canvasCompContain: ElementRef;
  @ViewChild('ocrPlus') ocrPlusRef: ElementRef<OcrPlusComponent>;

  fileName = '';
  uploadProgress: number | null;
  uploadSub: Subscription | null;
  imageURL: string;
  windowHeight = window.innerHeight - 20;
  loadingFlag = false;
  canvasComp: OcrPlusCanvasComponent;
  ocrPlus: OcrPlusComponent;
  err: any;
  error: string;
  dragAreaClass: string;
  draggedFiles: any;
  user: any;
  token: any;
  showNeedTopUp: boolean;
  jsonData: any;
  uid: string;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private api: APIService
  ) {}
  async ngOnInit() {
    this.dragAreaClass = 'dragarea';
    this.user = await Auth.currentUserInfo();

    if (this.user)
      this.token = await this.api.GetTokens(this.user.username);
  }

  ngAfterViewInit() {
    var ocrPlus = (this.ocrPlus = this
      .ocrPlusRef as unknown as OcrPlusComponent);
      ocrPlus.setItemOverHandler( (key, item) => {

        // receiptTbl.unchooseTr();
        // item.chosen = true;
        canvasComp.unchooseTr();
        canvasComp.itemOver(item);

      });      
    var canvasComp = (this.canvasComp = this
      .canvasCompRf as unknown as OcrPlusCanvasComponent);
    canvasComp.width = this.canvasCompContain.nativeElement.offsetWidth - 60;


    this.route.queryParams.subscribe((params) => {
      this.fileOcrUid(params['uid']);
    });

  }

  onFileChange(event: any) {
    let files: FileList = event.target.files;
    this.saveFiles(files);
  }

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }
  @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }
  @HostListener('dragend', ['$event']) onDragEnd(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }
  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }
  @HostListener('drop', ['$event']) onDrop(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      this.saveFiles(files);
    }
  }

  saveFiles(files: FileList) {
    if (files.length > 1) this.error = 'Only one file at time allow';
    else {
      this.error = '';
      let file = files[0];
      console.log(file.size, file.name, file.type);
      this.draggedFiles = files;
      console.log(files);

      this.filePreview(file);
      this.fileOcr(file);
    }
  }
  
  fileOcr(file) {
    if (file.size > 4000000) {
      alert('File size is too big. Max 4mb');
      return;
    }
    this.fileName = file.name;
    const formData = new FormData();
    formData.append('file', file);


    this.ocrPlus.restart();
    this.canvasComp.restart();
    this.err = null;
    this.loadingFlag = true;
    this.canvasComp.loadingFlag = true;
    const d2tApi = new D2TApi(this.http, this.token)
    const upload$ = d2tApi.ocrPlus(formData);
    upload$.pipe(
      catchError(this.handleError.bind(this)),
      finalize(() => {
        this.loadingFlag = false;
        this.canvasComp.loadingFlag = false;

        this.reset();
      })
    );

    this.uploadSub = upload$.subscribe((event) => {
      // console.log('event.type', event.type);

      if (event.type == HttpEventType.UploadProgress && event.total) {
        this.uploadProgress = Math.round(100 * (event.loaded / event.total));
      } else if (event.type == HttpEventType.Response) {
        this.loadingFlag = false;
        this.canvasComp.loadingFlag = false;

        const body = event.body as any;
        if (body.error) {
          if (body.needTopUp) {
            this.showNeedTopUp = true;
          } else {
            alert(body.error);
          }
          return;
        }
        this.ocrPlus.setOcrPlusData(event.body);
        let jsonData: any = event.body;
        if ( jsonData.uid )
          this.uid = jsonData.uid;
         
        this.canvasComp.setOcrPlus(this.ocrPlus);
      }
    });
  }


  fileOcrUid(uid = '') {
    // this.uid = uid;
    this.err = null;
    this.loadingFlag = true;
    const d2tApi = new D2TApi(this.http, this.token)
    const request = d2tApi.ocrPlusTst(uid);

    request.pipe(
      catchError(this.handleError.bind(this)),
      finalize(() => {
        this.loadingFlag = false;
        this.reset();
      })
    ).subscribe((data: any) => {
        if ( data.uid )
          this.uid = data.uid;

        this.ocrPlus.setOcrPlusData(data, { uid, isUid: true });

        this.canvasComp.setOcrPlus(this.ocrPlus);      

        this.loadingFlag = false;

      });

      
  }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      this.showError('An error occurred:' + error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      this.showError(`${error.message}`);
    }

    // return an observable with a user-facing error message
    return throwError('Acrion Failed');
  }

  filePreview(file) {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageURL = reader.result as string;
      var canvasComp = this.canvasComp;
      canvasComp.imageURL = this.imageURL;
      canvasComp.play();
    };
    reader.readAsDataURL(file);
  }

  clear() {
    var canvasComp = this.canvasComp;
    canvasComp.clear();
  }
  showError(err) {
    this.err = err;
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }
}
